import Commonenus from './en-us/common.json';
import Commonptbr from './pt-br/common.json';

export default {
  enus: {
    common: Commonenus,
  },
  ptbr: {
    common: Commonptbr,
  },
};
